import T from 'i18n-react'
import * as R from 'ramda'
import { createSelector } from 'reselect'
import {
  createSelectorWithPath,
  entitiesSelector
} from 'helpers/ComponentSelectorUtil'

const powerComponentsSelectorFunc = state => state && state.values ? state.values : []
const powerComponentsTypesSelectorFunc = state => state ? state.types : []

const powerComponentsTypesSelectorHoc = (powerComponentsTypesSelector) => (
  createSelector(
    entitiesSelector,
    powerComponentsTypesSelector,
    (entities, refs) => refs && refs.map(({id, type}) => {
      const value = entities[type][id].value
      return { value, label: value }
    })
  )
)

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const powerComponentsSelector = withPath(powerComponentsSelectorFunc)
  const powerComponentsTypesSelectorRef = withPath(powerComponentsTypesSelectorFunc)
  const powerComponentsTypesSelector = powerComponentsTypesSelectorHoc(powerComponentsTypesSelectorRef)

  return {
    powerComponentsSelector,
    powerComponentsTypesSelector
  }
}
